package com.parmartechnologies.core.network

import kotlinx.serialization.json.Json

open class BaseNetwork {
    val decoder = Json {
        encodeDefaults = true
        ignoreUnknownKeys = true
        isLenient = true
    }
}